// store/package/packageActions.ts
import { createAction } from '@reduxjs/toolkit';

import { PaymentProvider } from '../../app/Components/Modals/PaymentCheckoutModal';
import { Package } from '../types';

export type PaymentPayload = {
	amount: number;
	currency: string;
	remarks?: string;
	frontendUrl: string;
	pkg: Package;
	provider: PaymentProvider;
};

export const packagesRequest = createAction<{
	start: number;
	limit: number;
	filters?: {
		category?: string;
		status?: string;
		search?: string;
	};
}>('packages/request');

export const packagesSuccess = createAction<{
	items: Package[];
	total?: number;
}>('packages/success');

export const packagesFailure = createAction<string>('packages/failure');

// Optional: Single package actions
export const packageRequest = createAction<string>('package/request');
export const packageSuccess = createAction<Package>('package/success');
export const packageFailure = createAction<string>('package/failure');

export const paymentRequest = createAction<PaymentPayload>('payment/request');

export const paymentSuccess = createAction<{
	checkoutUrl?: string;
	depositId?: string;
	package?: any;
	provider?: string;
	transactionId?: string;
	/** EasyPay: the code the player pays with at an EasyPay office. */
	paymentCode?: string;
	newBalance?: number;
	isEpayForm?: boolean;
}>('packages/paymentSuccess');

export const paymentFailure = createAction<string>('payment/failure');

export const paymentReset = createAction('payment/reset');
